import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoggerService } from '../logger/logger.service';
import { LogsType } from '../../../shared/constants/logs-type.enum';

@Injectable({
  providedIn: 'root'
})
export class BusyService {
  private readonly className = 'BusyService';
  private functionName = '';
  private busyRequestCount = 0;

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly logger: LoggerService,
  ) { }

  busy(): void {
    this.functionName = 'busy'
    this.logger.logMessage(LogsType.TRACE, this.className, this.functionName);

    this.busyRequestCount++;
    this.spinner.show(
      undefined,
      {
        type: 'ball-scale-multiple',
        bdColor: 'rgba(0,0,0,0.75)',
        color: '#f5c542',
        size: 'large'
      }
    )
  }

  idle(): void {
    this.functionName = 'idle'

    this.busyRequestCount--;
    if(this.busyRequestCount <= 0){
      this.busyRequestCount = 0;
      this.spinner.hide();

      this.logger.logMessage(LogsType.TRACE, this.className, this.functionName, 'Resultado: Finalizado');
    }
  }
}
